import styles from './Laser.module.css';

interface LaserProps {
  className?: string;
}

export const Laser = ({ className }: LaserProps) => <div className={[styles.laser, className].join(' ')} />;
